<template>
  <div>
    <ul id="sheetselector">
      <template v-if="$router.currentRoute.name === 'animer' && !boardIsClosed">
        <li
          @click="addSheet"
          id="plusbutton"
          class="sheet"
        >+</li>
      </template>
      <draggable
        id="drag"
        v-model="currentSheetDrag"
        @start="drag=true"
        @end="drag=false"
      >
        <template v-for="sheet in current.sheets">
          <li
            @click="changeCurrentSheet(sheet.id)"
            :key="sheet.id"
            :class="['sheet', sheet.id === currentSheet ? 'active' : '']"
          >
            <template v-if="(editSheet) && (editSheetId === sheet.id)">
              <input
                @blur="editValue"
                v-model="editSheetName"
                name="NAME"
                tabindex="-1"
                class="input sheetEdit"
                type="text"
              />
            </template>
            <template v-else>
              <p :title="sheet.name">{{ sheet.name.length > 15 ? sheet.name.slice(0,15) + '...':sheet.name}}</p> ({{ currentBoardPost.filter(p => p.sheet_id === sheet.id).length }})
            </template>

            <template v-if="(!editSheet) && (sheet.id === currentSheet) && ($router.currentRoute.name === 'animer') && !boardIsClosed">
              <span @click="popup(sheet.id)">
                <b-icon
                  class="editsheet"
                  pack="fas"
                  icon="cog"
                  size="is-small"
                ></b-icon>
              </span>
              <template v-if="(current.sheets.length > 1)">
                <!-- <span @click="deleteSheetButton(sheet.id)">
                  <b-icon class="deleteSheet" pack="fas" icon="trash-alt" size="is-small"></b-icon>
                </span> -->
              </template>
            </template>
          </li>
        </template>
      </draggable>
    </ul>
    <!-- modal -->
    <b-modal
      :active.sync="isComponentModalActive"
      style="width: auto"
    >
      <udpateSheetPopup :index="this.index" />
    </b-modal>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import udpateSheetPopup from './modal/updateSheetPopup'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {
  name: 'sheetSelector',
  components: {
    draggable,
    udpateSheetPopup
  },
  data: function () {
    return {
      editSheet: false,
      editSheetId: null,
      editSheetName: '',
      isComponentModalActive: false,
      index: null
    }
  },
  computed: {
    ...mapState({
      current: 'current',
      currentSheet: 'currentSheet',
      currentBoardPost: 'currentBoardPost',
      boardIsClosed: "boardIsClosed"
    }),
    currentSheetDrag: {
      get: function () {
        return this.$store.state.board.current.sheets
      },
      set: function (newValue) {
        if (this.$router.currentRoute.name === 'animer') {
          newValue.forEach((element, index) => {
            element.order = index
            this.$store.dispatch('board/updateSheet', {
              board: this.current,
              sheet: element
            })
          })
          this.$store.commit('board/UPDATE_SHEET_LIST', newValue)
        }
      }
    }
  },
  methods: {
    popup (idSheet) {
      let message = {
        task: 'scrollToTop'
      }
      window.top.postMessage(message, '*')
      this.isComponentModalActive = true
      this.index = this.current.sheets.map(function (el) { return el.id }).indexOf(idSheet)
    },
    addSheet () {
      this.$store.dispatch('board/newSheet', {
        board: this.current,
        sheet: {
          name: this.$i18n.t('sheet.name') + (this.current.sheets.length + 1)
        }
      })
    },
    changeCurrentSheet (id) {
      if (id !== this.currentSheet) {
        this.toggleEdit(false)
        this.editSheetId = null
        this.$store.commit('board/CHANGE_CURRENT_SHEET', id)
      }
    },
    editValue () {
      if (this.editSheetId !== null) {
        this.$store.commit('board/UPDATE_SHEET', {
          name: this.editSheetName,
          id: this.editSheetId
        })
        this.$store.dispatch('board/updateSheet', {
          board: this.current,
          sheet: { name: this.editSheetName, id: this.editSheetId }
        })
        this.toggleEdit(false)
      }
    },
    deleteSheetButton (id) {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('button.annuler'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('sheet.supprimer.message'),
        onConfirm: () => this.deletesheet(id)
      })
    },
    deletesheet (id) {
      this.$store.dispatch('board/deleteSheet', {
        board: this.current,
        sheet: id
      })
    },
    editSheetButton (id) {
      this.toggleEdit(true)
      this.editSheetId = id

      let sheet = this.current.sheets.filter(sh => sh.id === id)[0]
      this.editSheetName = sheet.name
    },
    toggleEdit (val) {
      this.editSheet = val
    }
  }
}
</script>
<style scoped>
#sheetselector {
  display: flex;
  list-style: none;
  position: fixed;
  margin-top: 0px;
  padding: 0 5px;
  height: 40px;
  background: #e6ecf0;
  width: 100%;
  text-align: left;
  border-bottom: 3px solid #666;
}
.sheet {
  width: auto;
  height: 37px;
  line-height: 30px;
  cursor: pointer;
  vertical-align: middle;
  background: #e6ecf0;
  border-left: 3px solid #666;
  border-right: 3px solid #666;
  border-top: 3px solid #666;
  display: flex;
  flex-flow: row nowrap;
  padding: 0 6px;
  margin: 0 2px;
  margin-top: 3px;
  border-top-left-radius: 10px 10px;
  border-top-right-radius: 10px 10px;
}
#plusbutton {
  font-weight: bold;
}
#drag {
  display: flex;
  flex-flow: row wrap;
}
.active {
  background: white;
  color: black;
  /* font-weight: bold; */
}
.editsheet {
  margin-left: 10px;
}
.sheetEdit {
  height: 28px;
  margin-top: 2px;
}
.sheetEdit {
  height: 28px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/sheetSelector.vue